import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { AreaService } from 'src/app/services/area.service';
import { NewAreaComponent } from './new-area/new-area.component';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css']
})
export class AreaComponent implements OnInit {

  displayedColumns: string[] = ['nro', 'nombre', 'descripcion', 'opciones'];
  dataSource = new MatTableDataSource();
  id: number = 0;
  
  constructor(private areaService: AreaService,
      private dialog: MatDialog,
      private alert: AlertService,
      private router: Router,
      private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.listar();
  }

  listar() {
    this.areaService.getAreas()
      .subscribe((data:any) => {
        this.dataSource = new MatTableDataSource(data.data.data);
      });
  }

  public doFilter(strBuscar: string = '') {
    this.dataSource.filter = strBuscar.trim().toLocaleLowerCase();
  }

  agregar() {
    const dialogRef = this.dialog.open(NewAreaComponent, {
      disableClose: true,
      maxWidth: '640px'
    });
    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.listar();
        }
      });
  }

  editar(id:number) {
    this.areaService.getAreaById(id)
      .subscribe((data: any) => {
        if (data.status !== 200) {
          this.alert.showInfo('warning');
          return;
        }
        const dialogRef = this.dialog.open(NewAreaComponent, {
          disableClose: true,
          maxWidth: '640px',
          data: data.data.data
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.listar();
          }
        });
      },
      (err) => {
        this.alert.showInfo('error');
      });
  }

}
